/* eslint-disable */
import React from 'react';
import styles from './breakDown.module.scss';
import PropTypes from 'prop-types';
import {CURRENCY_SYMBOL} from '../../Constants/strings'

const Breakdown = ({ data, title,showSubText ,totalCost}) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div className={styles.staffingCostDiv}>
        <div className={styles.staffingCostHeader}>
          <span>{title || 'Breakdown'}</span>
          {showSubText && (
          <div className={styles.staffingCostAmt}>
            <span>{CURRENCY_SYMBOL} 0.0</span>
          </div>
          )}
        </div>
        <div className={styles.staffingCostAmtDiV}></div>
      </div>
    );
  }

  // Calculate total number for normalization
  const totalNumber = data.reduce((acc, category) => acc + (category.cost || 0), 0);

  const effortData = data
    .map((category) => ({
      color: category.color || '#cccccc',  // Default color if none provided
      resource: category.resource,
      cost: `${category.cost || 0} units`,
      percentage: parseFloat(category.percentage) || 0,
      value: category.cost,
    }))
    .filter((item) => item.value > 0); // Only show items with non-zero numbers

  const effortBars = data
    .map((category) => ({
      color: category.color || '#cccccc', // Default color
      cost: category.cost || 0,
      resource: category.resource,
    }))
    .filter((item) => item.cost > 0); // Only show items with non-zero numbers

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        
        <div className={styles.title}>{title || 'Efforts Breakdown'}</div>
        {showSubText && (
        <div className={styles.subText}>
            <span>{CURRENCY_SYMBOL} {totalCost}</span>
          </div>
            )}
        <div className={styles['breakdown-container']}>
          {effortData.map((item) => (
            <div className={styles['breakdown-item']} key={item.resource}>
              <div
                className={styles.indicator}
                style={{ background: item.color }}
                aria-label={`Category: ${item.resource} - Percentage: ${item.percentage}%`}
              />
              <div className={styles.label}>
                {item.resource}
              </div>
              <div className={styles.separator}></div>
            </div>
          ))}
        </div>
      </div>

      <div className={styles['effort-bar-container']}>
        {effortBars.map((bar) => {
          const barWidth = totalNumber ? (bar.cost / totalNumber) * 100 : 0;
          return (
            <div
              className={styles['effort-bar']}
              key={bar.resource}
              style={{ background: bar.color, width: `${barWidth}%` }}
              aria-label={`${bar.resource} - ${bar.cost} units`}
            >
              <div className={styles['effort-label']}>{CURRENCY_SYMBOL} {bar.cost}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

Breakdown.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      resource: PropTypes.string.isRequired, // category label
      color: PropTypes.string, // optional custom color for each category
      cost: PropTypes.cost, // number of units for the category
      percentage: PropTypes.string, // percentage for the category
    })
  ).isRequired,
  title: PropTypes.string,  // Optional title prop
  showSubText: PropTypes.bool,  // Optional prop to control  total cost to be  visibility
  totalCost: PropTypes.number, // total cost to be displayed
};

export default Breakdown;
